import React, { useMemo, useCallback } from 'react';
import { useFormContext, UseFieldArrayRemove } from 'react-hook-form';
import { useIntl } from 'react-intl';

import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';

import DeleteIcon from '@mui/icons-material/Delete';

import { FormTextField } from '@ts-core/core/components/FormV2';

import { FillInTheBlanksExerciseInput } from '../../types/form';

import FillInTheBlanksQuestionPreview from '../FillInTheBlanksQuestionPreview';
import { getPreviewText, getTextFormatError } from '../../utils';

interface FillInTheBlanksQuestionFieldProps {
  index: number;

  onRemove: UseFieldArrayRemove;
}

const FillInTheBlanksQuestionField = (props: FillInTheBlanksQuestionFieldProps) => {
  const { index, onRemove } = props;
  const intl = useIntl();
  const { control, watch } = useFormContext<FillInTheBlanksExerciseInput>(); // retrieve all hook methods
  const questionText = watch(`questions.${index}.text`);

  const handleRemoveQuestion = useCallback(() => {
    onRemove(index);
  }, [onRemove, index]);

  const formatError = useMemo(() => {
    return getTextFormatError(questionText);
  }, [questionText]);

  const previewText = useMemo(() => {
    return getPreviewText(questionText);
  }, [questionText]);

  return (
    <Box display="flex" alignItems="center" width="100%">
      <Box display="flex" flexDirection="column" flexGrow={1} p={2} border={1} borderColor="grey.400">
        <FormTextField
          // sx={{ mt: 2 }}
          label={intl.formatMessage({ id: 'field.paragraph' })}
          control={control}
          name={`questions.${index}.text`}
          multiline
          minRows={2}
          maxRows={6}
        />
        <FillInTheBlanksQuestionPreview text={previewText} error={formatError} sx={{ mt: 2 }} />
      </Box>
      <Box width={36}>
        {index > 0 && (
          <IconButton onClick={handleRemoveQuestion} size="small">
            <DeleteIcon />
          </IconButton>
        )}
      </Box>
    </Box>
  );
};

export default FillInTheBlanksQuestionField;
